import { Component, Input, OnInit } from '@angular/core';
import { EveReportingWidget, EveReportingWidgetType } from '../../widget.component';




@Component({
  selector: 'widget-control-type-menu-settings',
  templateUrl: 'widget-control-type-menu-settings.component.html',
  styleUrls: ['./widget-control-type-menu-settings.component.css']
})
export class WidgetControlTypeMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingWidget = null;

  

  widgetTypes = EveReportingWidgetType;


  constructor(

  ) {


  }
    ngOnInit(): void {
    }


}



